export const getDomainTypeFromPath = (path: string) => path.split('/').shift();
